var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.subscriptionFeatureAllowed)?_c('button',{staticClass:"btn btn-outline-secondary w-100",on:{"click":_vm.gotoHome}},[_c('i',{staticClass:"fas fa-home"}),_vm._v(" Home ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }